import { api } from "@/lib/api";

export type TaskStatus = "TODO" | "IN_PROGRESS" | "DONE" | "CANCELLED";
export type TaskPriority = "LOW" | "MEDIUM" | "HIGH";

export type CalendarCell = {
  iso: string;
  day: number;
  in_month: boolean;
  is_today: boolean;
};

export type CalendarEvent = {
  task_id: string;
  title: string;
  description: string;
  priority: TaskPriority;
  status: TaskStatus;
  start_time: string | null;
  end_time: string | null;
  time_label: string | null;
  start_sort: number;
  assignee: string | null;
};

export type FlatTask = {
  task_id: string;
  title: string;
  description: string;
  priority: TaskPriority;
  start_date: string | null;
  due_date: string | null;
  status: TaskStatus;
  assigned_at: string | null;
  completed_at: string | null;
};

export type TasksDashboard = {
  tz_name: string;
  month_value: string;
  month_label: string;
  prev_month_value: string;
  next_month_value: string;
  selected_status: string;
  all_statuses: TaskStatus[];
  weeks: CalendarCell[][];
  events_by_day: Record<string, CalendarEvent[]>;
  tasks: FlatTask[];
  counts: { total: number; pending: number; done: number };
};

export type TaskAssignee = {
  user_id: string | null;
  name: string | null;
  email: string | null;
  status: TaskStatus;
  completed_at: string | null;
};

export type TaskDetail = {
  task_id: string;
  title: string;
  description: string;
  priority: TaskPriority;
  start_date: string | null;
  due_date: string | null;
  my_status: TaskStatus;
  my_completed_at: string | null;
  all_statuses: TaskStatus[];
  assignees: TaskAssignee[];
};

export async function fetchTasksDashboard(params: {
  month?: string;
  status?: string;
}): Promise<TasksDashboard> {
  const q: Record<string, string> = {};
  if (params.month) q.month = params.month;
  if (params.status) q.status = params.status;
  const { data } = await api.get<TasksDashboard>("/api/web/tasks/my", { params: q });
  return data;
}

export async function fetchTaskDetail(id: string): Promise<TaskDetail> {
  const { data } = await api.get<TaskDetail>(`/api/web/tasks/${id}`);
  return data;
}

export async function updateMyTaskStatus(
  id: string,
  status: TaskStatus
): Promise<TaskDetail> {
  const { data } = await api.post<TaskDetail>(`/api/web/tasks/${id}/status`, {
    status,
  });
  return data;
}
